import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { Step5Props, useStep5Props } from '../types'
import { useAlertDialog } from './useStep5.alertDialog'
import useStep5Ares from './useStep5.ares'
import useStep5Form from './useStep5.form'
import useStep5FormConditions from './useStep5.form.conditions'
import useStep5FormOptions from './useStep5.form.options'
import useStep5FormStreet from './useStep5.form.street'

const useStep5 = (props: useStep5Props): Step5Props => {
    const { data: activationObject, isUpdating } = useActivationObject()
    const aresProps = useStep5Ares(activationObject)
    const formProps = useStep5Form(aresProps, activationObject)
    const optionsProps = useStep5FormOptions(formProps.form, aresProps, activationObject)
    const conditionsProps = useStep5FormConditions(formProps.form, optionsProps, aresProps, activationObject)
    const streetSugestionsProps = useStep5FormStreet(formProps.form)
    const alertDialog = useAlertDialog({ form: formProps.form, activationObject })

    return {
        ...props,
        activationObject,
        ares: aresProps,
        form: formProps,
        options: optionsProps,
        conditions: conditionsProps,
        streetSugestions: streetSugestionsProps,
        isUpdating,
        alertDialog,
    }
}

export default useStep5
